"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Trigger = exports.HeroTitle = exports.HeroImage = exports.HeroCreditsGroup = exports.HeroCreditsContainer = exports.HeroCredits = exports.HeroContainer = exports.HeroBottomContainer = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  width: 100vw;
  ${(0, _layout.setContainer)({
  size: 'sm'
})}
  display: flex;
  img {
    object-fit: contain;
    max-height: 100%;
    max-width: 100%;
  }

  padding: 0px;

  @media (min-width: 768px) {
    max-height: 100%;
  }
`;
exports.Container = Container;
const Trigger = _styledComponents.default.div`
  position: relative;
  color: ${props => props.colorMode === 'dark' ? 'white' : 'inherit'};
  background-color: ${props => {
  if (props.backgroundColor) {
    return props.backgroundColor.hex;
  }
  return props.colorMode === 'dark' ? 'black' : 'transparent';
}};

  @media (min-width: 768px) {
    height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
  }
`;
exports.Trigger = Trigger;
const Wrapper = _styledComponents.default.div`
  padding: 30px 0px;

  @media (min-width: 768px) {
    position: absolute;
    top: 0vh;
    left: 0;
    display: flex;
    flex-direction: row !important;
    flex-wrap: nowrap;
    height: 100%;
    align-items: center;
    height: 100vh;
    padding: 120px 0px 50px; // leave space for hs header
  }

  p {
    a {
      text-decoration: none !important;
      color: ${props => props.colorMode === 'dark' ? 'white' : 'inherit'};
      border-bottom: 1px solid
        ${props => {
  return props.colorMode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.4)';
}};
      transition: 0.15s all;

      &:hover {
        border-color: ${props => props.colorMode === 'dark' ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,1)'};
      }
    }
  }
  a.bricks-cta {
    color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    border: 1px solid
      ${props => props.colorMode === 'dark' ? 'white' : 'black'};

    &:hover {
      color: ${props => props.colorMode === 'dark' ? 'black' : 'white'};
      background-color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
      border-color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    }
  }

  a.shopping-carousel {
    color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    text-decoration: none;
  }

  div.credits-container {
    border-top: 1px solid
      ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    svg path {
      stroke: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    }
  }
`;
exports.Wrapper = Wrapper;
const HeroImage = _styledComponents.default.div`
  background-image: url('${props => props.src}');
  width: 100%;
  background-size: cover;
  background-position: center;
  padding-top: 100%;
  margin-top: 60px;

  @media (min-width: 768px) {
    height: 20vh;
    width: 30vh;
    min-width: 30vh;
    padding-top: 0px;
    margin-top: 0px;
  }

  @media (min-width: 992px) {
    height: 30vh;
    width: 45vh;
    min-width: 45vh;
    padding-top: 0px;
    margin-top: 0px;
  }
`;
exports.HeroImage = HeroImage;
const HeroContainer = _styledComponents.default.div`
  height: 100%;
  width: 100vw;
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 767px) {
    margin-bottom: 32px;
  }

  @media (min-width: 768px) {
    padding: 30px 60px;
    width: 120vw;
  }

  @media (min-width: 992px) {
    padding: 30px 60px;
    width: 80vw;
    min-width: 80vw;
  }

  color: ${props => props.colorMode === 'dark' ? 'white' : 'inherit'};
  background-color: ${props => {
  if (props.backgroundColor) {
    return props.backgroundColor;
  }
  return props.colorMode === 'dark' ? 'black' : 'transparent';
}};
`;
exports.HeroContainer = HeroContainer;
const HeroTitle = _styledComponents.default.h1`
  line-height: 1em;
  font-weight: normal;
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${props => {
  let fontProps = {};
  if (props.typeface === 'black') {
    fontProps.headline = true;
  } else if (props.typeface === 'deville') {
    fontProps.display = true;
  } else if (props.typeface === 'condensed') {
    fontProps.condensed = true;
  }
  return (0, _typography.setFont)({
    ...fontProps
  });
}}

  color: ${props => {
  return props.color?.hex || 'inherit';
}};
  text-transform: ${props => props.typeface === 'black' || props.typeface === 'condensed' ? 'uppercase' : 'capitalize'};

  ${(0, _typography.setFontSizes)({
  xs: '38px',
  sm: '48px',
  xl: '4vw'
})}

  @media (min-width: 992px) {
    max-width: 75%;
  }
`;
exports.HeroTitle = HeroTitle;
const HeroCreditsContainer = _styledComponents.default.div`
  display: flex;
  min-width: 50%;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
  }
`;
exports.HeroCreditsContainer = HeroCreditsContainer;
const HeroCredits = _styledComponents.default.p`
  ${(0, _typography.setFont)({
  bold: false
})}
  ${(0, _typography.setFontSizes)({
  xs: '12px'
})}
  margin: 0px;
  max-width: 180px;
`;
exports.HeroCredits = HeroCredits;
const HeroBottomContainer = _styledComponents.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
exports.HeroBottomContainer = HeroBottomContainer;
const HeroCreditsGroup = _styledComponents.default.div`
  max-width: 240px;

  @media (min-width: 768px) {
    padding: 0 40px;
  }
`;
exports.HeroCreditsGroup = HeroCreditsGroup;
//# sourceMappingURL=styles.js.map